import api from "../services/api";

export const fetchReferralStats = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      `/loyalty-management/admin/referrals?page=${page}&size=${size}`
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to fetch referral stats",
    };
  }
};